import { ProfileModel } from '@vp/profile/core/model/ProfileModel';

export abstract class AvatarManagerRepository {
  abstract upload(profileId: string, avatarFile: File, controller?: AbortController): Promise<ProfileModel>;
  abstract remove(profileId: string, avatarId: string, controller?: AbortController): Promise<ProfileModel>;
}
